export const SAMPLE_COVERS = Array.from({ length: 54 }, (_, i) => {
  const num = String(i + 4).padStart(2, "0");
  return `/covers/cover_${num}.jpg`;
});

export function randomCover(): string {
  return SAMPLE_COVERS[Math.floor(Math.random() * SAMPLE_COVERS.length)];
}

/**
 * Deterministic cover based on a string key (e.g. project ID).
 * Always returns the same cover for the same key.
 */
export function coverForId(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = ((hash << 5) - hash + id.charCodeAt(i)) | 0;
  }
  return SAMPLE_COVERS[Math.abs(hash) % SAMPLE_COVERS.length];
}

export const DEFAULT_COVER = SAMPLE_COVERS[0];

export async function fetchPresetCoverAsFile(url: string): Promise<File> {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Failed to load preset cover: ${res.status}`);
  const blob = await res.blob();
  const filename = url.split("/").pop() ?? "cover.jpg";
  const type = blob.type || "image/jpeg";
  return new File([blob], filename, { type });
}
